<div>


  <div class="nav-under container-fluid header-borders border-bottom py-2">
    <nav aria-label="breadcrumb" class="row">
      <div class="col-md-10">
        <ol class="breadcrumb bg-white page-title" style="margin-bottom: 0;">
          <li class="breadcrumb-item ">App Content</li>
          <li class="breadcrumb-item active" aria-current="page">Financial Literacy</li>
        </ol>
      </div>
    </nav>
  </div>

  <div class="dash-section">
    <div class="py-3 border-bottom mb-3">
      <div class="mx-0 row">
        <div class="col-6 col-md">
          <span class="btn float-left">
            All topics ({{ topicsCount }})
          </span>
          <button
            class="btn btn-primary"
            data-toggle="modal"
            data-target="#addLiteracyTopicModal"
          >
            Add topic
          </button>
        </div>
        <div class="col-6 col-md-auto">
          <div class="searchbox">
            <input
              type="text"
              class="form-control"
              placeholder="Search"
              (keyup)="filterLiteracyTopics($event)">
              <span class="fa fa-search"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row" >
        <div class="col-6 col-lg-2" *ngFor="let _topic of filteredLiteracyTopicsData">
          <a (click)="getTopicDetails(_topic.topic, selectedLanguage)" class="btn btn-lite btn-block text-left">
          <img src="https://img.icons8.com/fluent/48/000000/folder-invoices.png"/>
          {{_topic.topic}}
          </a>
        </div>
      </div>
      <div class="spinner d-flex" *ngIf="isLoadingTopics">
          <span class="spinner-border spinner-border-md mx-auto update-loading" role="status"></span>
      </div>
      <div class="m-4">&nbsp;</div>
    </div>
  </div>

  <!-- Add financial literacy topic modal -->
  <div class="modal fade" id="addLiteracyTopicModal" tabindex="-1" role="dialog" aria-labelledby="addLiteracyTopicModal"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-lg" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Add Topic</h5>
          <button type="button" class="close close-btn"  aria-hidden="true" data-dismiss="modal" (click)="resetAddModal()">&times;</button>
        </div>
        <div class="modal-body">
          <form
            class="form"
            id="topicForm"
            #addLiteracyTopicForm="ngForm"
            (ngSubmit)="addLiteracyTopic(addLiteracyTopicForm.value)"

          >
            <div class="form-group">
              <label for="topic">Topic</label>
              <input
                type="text"
                class="form-control"
                name="topic"
                ngModel
                #topic="ngModel"
                required
              />
              <div
                *ngIf="topic.dirty || (topic.touched && !topic.valid)"
                class="text-danger error_message"
              >
                <span *ngIf="topic.hasError('required')">
                  Please the topic is required
                </span>
              </div>
            </div>

            <div class="form-group">
              <label for="description">Description</label>
              <quill-editor
                name="description"
                #description="ngModel"
                [(ngModel)]="model.description"
                [modules]="quillConfig"
                [styles]="editorStyle"
              >
              </quill-editor>
            </div>

            <div class="form-group">
              <label>Image</label>
              <input
                type="file"
                class="form-control file-input"
                name="photo"
                (change)="changeImage($event)"
                accept="image/png, image/jpeg, image/jpg"
              />
            </div>
            <br>
            <div>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!addLiteracyTopicForm.form.valid"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save changes
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
